import React, { useState, useEffect } from 'react';
import { sendRequest } from '../../hooks/fetchData';
import { useUserContext } from "../../store/user_context";
import { getLastMonth21st, formatDateForInput} from '../../utils/dateUtils';

const UserOrderArchieve = () => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [archiveData, setArchiveData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);
    const { user } = useUserContext();

    const apiUrl = import.meta.env.VITE_API_URL;
    const getArchiveReportEndpoint = import.meta.env.VITE_get_user_archived_orders;

    useEffect(() => {
        const fromDate = getLastMonth21st();
        const toDate = formatDateForInput(new Date());
       
        setFromDate(fromDate);
        setToDate(toDate);
    }, []);

    const handleSearch = async () => {
        if (!fromDate || !toDate) {
            setError('يرجى اختيار تاريخ البداية والنهاية');
            return;
        }

        setLoading(true);
        setError(null);
        setHasSearched(true);

        try {
            const url = `${apiUrl}${getArchiveReportEndpoint}?userId=${user?.userId}&fromDate=${fromDate}&toDate=${toDate}`;
            const { done, data, isError } = await sendRequest(url);

            if (done && !isError) {
                setArchiveData(data || []);
            } else {
                setError('حدث خطأ في جلب البيانات');
            }
        } catch (err) {
            setError('حدث خطأ في الاتصال بالخادم');
            console.error('Error fetching archive data:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleViewDetails = (order) => {
        setSelectedOrder(order);
    };

    const closeDetailsModal = () => {
        setSelectedOrder(null);
    };

    const calculateTotal = () => {
        return archiveData.reduce((sum, order) => sum + order.orderTotalPrice, 0);
    };

    const formatDate = (dateString) => {

        return dateString.split('T')[0];
    };

    return (
        <>
            <section className="main_content">
                <div className="container">
                    <h1 className="page-title">تقرير أرشيف الطلبات</h1>

                    {/* Date Filters */}
                    <div className="date-filters">
                        <div className="form-group">
                            <div className="date-input-group">
                                <label>من:</label>
                                <input
                                    type="date"
                                    id="fromDate"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>
                            <div className="date-input-group">
                                <label>إلى:</label>
                                <input
                                    type="date"
                                    id="toDate"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </div>
                            <button className="btn btn-primary" onClick={handleSearch} disabled={loading}>
                                {loading ? 'جاري البحث...' : 'بحث'}
                            </button>
                        </div>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <div className="alert danger">
                            {error}
                        </div>
                    )}

                    {/* Archive Report Table */}
                    {archiveData.length > 0 && (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>المسلسل</th>
                                    <th>رقم الطلب</th>
                                    <th>التاريخ</th>
                                    <th>الإجمالي</th>
                                    <th>التفاصيل</th>
                                </tr>
                            </thead>
                            <tbody>
                                {archiveData.map((order, index) => (
                                    <tr key={order.orderId}>
                                        <td>{index + 1}</td>
                                        <td>{order.orderNumber}</td>
                                        <td>{formatDate(order.orderDate)}</td>
                                        <td>{order.orderTotalPrice.toFixed(2)}</td>
                                        <td>
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => handleViewDetails(order)}
                                            >
                                                التفاصيل
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {/* Total Row */}
                                <tr className="total">
                                    <td colSpan="3">الإجمالي</td>
                                    <td>{calculateTotal().toFixed(2)}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    )}

                    {/* No Data Message */}
                    {!loading && hasSearched && archiveData.length === 0 && !error && (
                        <div className="no-data">
                            <p>لا توجد طلبات في الفترة المحددة</p>
                        </div>
                    )}

                    {/* Loading Message */}
                    {loading && (
                        <div className="loading-message">
                            <p>جاري تحميل البيانات...</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Order Details Modal */}
            {selectedOrder && (
                <div className="modal-overlay" onClick={closeDetailsModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>تفاصيل الطلب - {selectedOrder.orderNumber}</h2>
                            <button className="close-btn" onClick={closeDetailsModal}>×</button>
                        </div>
                        <div className="modal-body">

                            {selectedOrder.orderDetails.map((detail, index) => (
                                <div key={index}>
                                    <h4>{detail.resturantName}</h4>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>الصنف</th>
                                                <th>العدد</th>
                                                <th>السعر</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detail.mealsDetails.map((meal, mealIndex) => (
                                                <tr key={mealIndex}>
                                                    <td>{meal.name}</td>
                                                    <td>{meal.count}</td>
                                                    <td>{meal.price.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserOrderArchieve;